import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Col, message, Row, Upload } from "antd";
import axios from "axios";
import React, { useState } from "react";
import Logout from "../../containers/Pages/Login/Logout";
import {
  Import_Lead_URL,
  Lead_Service_URL,
  staticFileUrl,
} from "../../redux/Url";
import LeadUploadCard from "../LeadCard";

const LeadUploadStepper = (props) => {
  const { adminFirstName, adminLastName, closeLeadUploadStepper, userDetail } =
    props;
  const [leadData, setLeadData] = useState({
    totalRecords: 0,
    success: 0,
    error: 0,
    url: "",
  });

  const staticUrl = Import_Lead_URL;

  const uploadLeadDataProps = {
    name: "file",
    accept: ".xls, .xlsx",
    action: `${Lead_Service_URL}/bulkUploadExcelPartnerLead?flag=true`,
    headers: {
      Authorization: `${userDetail?.accessToken?.token_type} ${userDetail?.accessToken?.access_token}`,
    },
    multiple: false,
    maxCount: 1,
    beforeUpload(file) {
      const isExcel = /xls|xlsx/.test(file.name);
      if (!isExcel) {
        message.error(`${file.name} is not an excel file`);
      }
      return isExcel || Upload.LIST_IGNORE;
    },
    onChange(info) {
      if (info.file.status === "done" && info?.file?.response?.success) {
        message.success(`${info.file.name} file uploaded successfully`);
        const tempUrl = info.file.response.statusFile.indexOf("/UploadExcel");
        setLeadData({
          totalRecords: info.file.response.totalCount,
          success: info.file.response.successCount,
          error: info.file.response.errorCount,
          url: `${staticUrl}${info.file.response.statusFile.slice(37)}`,
        });
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
        setLeadData({
          totalRecords: 0,
          success: 0,
          error: 0,
          url: "",
        });
      }
    },
  };

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <Row style={{ marginTop: 20 }} className="lead-flex-row">
        <Col xs={0} lg={24}>
          <div className="login-profie">
            <div className="img-sec">
              <h2>
                {adminFirstName(
                  userDetail?.firstName ??
                    userDetail?.userName?.split(" ")[0]?.trim()
                )}
              </h2>
              <h2>
                {adminLastName(
                  userDetail?.lastName ??
                    userDetail?.userName?.split(" ")[1]?.trim()
                )}
              </h2>
            </div>

            <div className="content-login">
              <h4>{userDetail?.userName}</h4>
              <h5>{userDetail?.roleName}</h5>
              <div className="content-login-data">
                <div className="admin-small-space"> </div>
                <Logout />
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row
        className="lead-flex-row"
        style={{ marginTop: 50, minHeight: "70vh" }}
        align="middle"
      >
        <Col xs={3}>
          <ArrowLeftOutlined
            style={{ color: "#00b1b1", fontSize: 20, cursor: "pointer" }}
            onClick={closeLeadUploadStepper}
          />
        </Col>
        <Col xs={21}>
          <h5 style={{ color: "#00b1b1" }}>IMPORT LEADS</h5>
        </Col>
        <Col xs={24}>
          <Row
            className="lead-flex-row"
            style={{ marginTop: 50 }}
            gutter={[
              { xs: 0, sm: 0, md: 0, lg: 32 },
              { xs: 32, sm: 32, md: 32, lg: 0 },
            ]}
          >
            <Col xs={24} lg={{ span: 7, offset: 3 }}>
              <LeadUploadCard>
                <LeadUploadCard.Header>1</LeadUploadCard.Header>
                <LeadUploadCard.Title>STEP</LeadUploadCard.Title>
                <LeadUploadCard.Body>
                  DOWNLOAD SAMPLE TEMPLATE
                </LeadUploadCard.Body>
                <LeadUploadCard.Actions>
                  <a
                    href={`${staticUrl}/UploadExcel/PartnerLeadExcel.xlsx`}
                    alt="Download Sample Template"
                  >
                    <Button className="text-button" type="text">
                      CLICK TO DOWNLOAD
                    </Button>
                  </a>
                </LeadUploadCard.Actions>
              </LeadUploadCard>
            </Col>

            <Col xs={24} lg={{ span: 7 }}>
              <LeadUploadCard>
                <LeadUploadCard.Header>2</LeadUploadCard.Header>
                <LeadUploadCard.Title>STEP</LeadUploadCard.Title>
                <LeadUploadCard.Body>
                  UPLOAD FILE WITH LEAD DATA
                </LeadUploadCard.Body>
                <LeadUploadCard.Actions>
                  <Upload {...uploadLeadDataProps}>
                    <Button className="text-button" type="text">
                      CLICK TO UPLOAD
                    </Button>
                  </Upload>
                </LeadUploadCard.Actions>
              </LeadUploadCard>
              <div
                style={{
                  paddingTop: 5,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  TOTAL RECORDS:{" "}
                  <span style={{ color: "#00b1b1" }}>
                    {leadData.totalRecords}
                  </span>
                </div>
              </div>
            </Col>

            <Col xs={24} lg={{ span: 7 }}>
              <LeadUploadCard>
                <LeadUploadCard.Header>3</LeadUploadCard.Header>
                <LeadUploadCard.Title>STEP</LeadUploadCard.Title>
                <LeadUploadCard.Body>
                  DOWNLOAD IMPORT STATUS
                </LeadUploadCard.Body>
                <LeadUploadCard.Actions>
                  <a href={leadData.url} alt="Download lead">
                    <Button className="text-button" type="text">
                      CLICK TO DOWNLOAD
                    </Button>
                  </a>
                </LeadUploadCard.Actions>
              </LeadUploadCard>
              <div
                style={{
                  paddingTop: 5,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  SUCCESS:{" "}
                  <span style={{ color: "#00b1b1" }}>{leadData.success}</span>
                </div>
                <div>
                  ERROR:{" "}
                  <span style={{ color: "#00b1b1" }}>{leadData.error}</span>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default LeadUploadStepper;
